<template>
    <div ref="spContainer" class="sp-container" @mouseenter="showSituationCard()" @mouseleave="showSituationCard()">
        <div @click="gotoSituation()">
          <div class="sp-dot" :class="{ 'sp-currentSituation': currentSituationID == situation.id}"/>
          <div class="sp-ppl" v-if="usersLength && enableCommunication">{{usersLength}}</div>
        </div>
        
        <transition name="fade">
            <SituationCard ref="spCard" class="sp-card" v-show="showCard" :situation="situation" :style="cardPosition"/>
        </transition>
    </div>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex';
import SituationCard from '@/components/flux360/EmbeddedDialogues/MapDialogue/SituationCard'

export default {
    components: {SituationCard},
    props: ['situation'],
    inject: ['toggleMap'],
	data: () => ({
        showCard: false,
    }),
	methods: {
        ...mapMutations(["handleGotoSituationTransition"]),
		showSituationCard(){
            this.showCard =! this.showCard;
        },
        gotoSituation(){
            this.toggleMap();
            this.handleGotoSituationTransition({situationID: this.situation.id});     
        }
    },
    computed: {
        ...mapGetters(['currentSituationID',"users","enableCommunication"]),
        usersLength(){
            return this.users.filter( x => x.getCurrentSituationID() == this.situation.id).length;
        },
        cardPosition(){
            // console.log(this.$refs.spContainer);
            if(!this.$refs.spContainer)
                return
            
        }
    },
    mounted: function(){
        console.log()
        let style = getComputedStyle(this.$refs.spContainer);
        let left = parseInt(style.left);
        let top = parseInt(style.top);
        if(top>60)
            this.$refs.spCard.$el.style.top = "-270px";
        if(left>60)
            this.$refs.spCard.$el.style.left = "-480px";
    }
}
</script>

<style>
.sp-container:hover .sp-dot {
    transform: scale(2);
    z-index: 5;
}
.sp-container:hover .sp-ppl{
    transform: scale(1.5);
    z-index: 6;
    cursor: pointer;
}
.sp-dot{
    z-index: 1;
    position: relative;
    cursor: pointer;
    height: 30px;
    width:  30px;
    border-radius: 50%;
    background: var(--secondaryColor);
    display: inline-block;
    filter: drop-shadow(0px 0px 2px  var(--secondaryColor)) drop-shadow(0px 0px 2px  var(--secondaryColor));
    transition: background-color .2s, transform .2s, filter .2s;
}
.sp-ppl{
    z-index: 3;
    position: absolute;
    font-size: 18px;
    left: 50%;
    top: 70%;
    height: 30px;
    width: 30px;
    background-color: rgb(39, 39, 39);
    border-radius: 50%;  
    text-align: center;
    line-height: 32px;
    color: rgb(231, 231, 231);
    transition: transform .2s;
}
.sp-card{
    width: 500px;
    height: 300px;
    position: absolute !important;
    top: 15px;
    left: 15px;
    z-index: 4;
    border-radius: 5px;
    overflow: hidden;
}
.sp-currentSituation{
    transform: scale(1.5);
    z-index: 2;
    background: var(--primaryColor);
    filter: drop-shadow(0px 0px 2px  var(--primaryColor)) drop-shadow(0px 0px 2px  var(--primaryColor));
}

/*DESKTOP SMALL*/
@media (max-width: 1200px) { 
   .sp-dot{
        height: 25px;
        width:  25px;
    }
    .sp-ppl{
        font-size: 14px;
        height: 15px;
        width: 15px;
        line-height: 15px;
    }
}
</style>